import camelcaseKeys from 'camelcase-keys'
import { TIME_FORMAT, FIRST_DAY_OF_WEEK } from '@/config/environment'
export class WebappUser {
  constructor (params = {}) {
    const { id, languageCode, facilityId, displayCurrencyId, timeFormat, firstDayOfWeek } = params ? camelcaseKeys(params) : {}
    this.id = id || null
    this.languageCode = languageCode || null
    this.facilityId = facilityId || null
    this.displayCurrencyId = displayCurrencyId || null
    this.timeFormat = timeFormat || TIME_FORMAT
    this.firstDayOfWeek = firstDayOfWeek || FIRST_DAY_OF_WEEK
  }
  serialize (editedFields) {
    var item = JSON.parse(JSON.stringify(this))
    Object.keys(editedFields).forEach(key => {
      item[key] = editedFields[key]
    })
    return {
      id: item.id,
      languageCode: item.languageCode,
      facilityId: item.facilityId,
      displayCurrencyId: item.displayCurrencyId,
      email: item.email || null,
      timeFormat: item.timeFormat,
      firstDayOfWeek: item.firstDayOfWeek,
    }
  }
}
